<template>
  <div 
    v-if="show" 
    class="cu-success-modal-backdrop"
    @click="$emit('close')"
  >
    <div class="cu-success-modal-dialog" @click.stop>
      <div class="modal-content msgModel-content border-light-grey">
        <div class="modal-header">
          <button 
            type="button" 
            class="close" 
            @click="$emit('close')"
            aria-label="Close"
            t_label="btn_emp2_Close_ContactUsSuccessModal"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-title h5 msgModel-title pl-3 pr-3" style="margin:0px;" id="MsgModalLabel"></div>
        <div class="modal-body h6 msgModel-body pl-3 pr-3 mb-5" style="color: rgb(0, 0, 0);" :key="currentLocale">
          {{ $t('lbl_emp2_contactus_message') }}
        </div>
        <div class="modal-footer msgModel-footer text-center d-none">
          <a class="btn btn-red msgModel-button left-btn"></a>
          <a class="btn btn-red msgModel-button right-btn"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUsSuccessModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentLocale() {
      // 获取当前语言设置，用于强制重新渲染
      return this.$i18n && this.$i18n.locale ? this.$i18n.locale : (localStorage.getItem('currentLangId') || '1252');
    }
  }
};
</script>

<style scoped>
.cu-success-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10001;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.cu-success-modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: auto;
  max-width: 500px;
  width: 90%;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.msgModel-content {
  border: 1px solid #ddd;
}

.border-light-grey {
  border-color: #ddd;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.close {
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
  background: transparent;
  border: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  cursor: pointer;
}

.close:hover {
  opacity: 0.75;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.h5 {
  font-size: 1.25rem;
}

.pl-3 {
  padding-left: 1rem;
}

.pr-3 {
  padding-right: 1rem;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.h6 {
  font-size: 1rem;
}

.mb-5 {
  margin-bottom: 3rem;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.text-center {
  text-align: center;
}

.d-none {
  display: none;
}

.msgModel-footer {
  display: none;
}
</style>

